import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Grid, Paper, Stack, useTheme } from "@mui/material";
import { GeneratePdfButton } from "components/GeneratePdfButton";

import { useFulfillmentDetails } from "./useFulfillmentDetails";

export function DownloadReport() {
  const theme = useTheme();
  const { data } = useFulfillmentDetails();

  return (
    <Stack
      direction="column"
      component={Paper}
      elevation={0}
      spacing={2}
      padding={theme.spacing(2, 3, 2, 3)}
    >
      <Grid size={12} sx={{ pt: 0 }}>
        <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
          {
            <GeneratePdfButton
              reportId={data?.tierIIReport.id ?? ""}
              label="Download Options"
              includeTierIISubmit={true}
              reportOrgStatus={data?.tierIIReport.organizationStatus}
              disabled={!data?.tierIIReport.id?.length}
              size="small"
              endIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
            />
          }
        </Box>
      </Grid>
    </Stack>
  );
}
